"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AWSAthenaParametersV2 = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _tabs = _interopRequireDefault(require("@insided/deprecated-control/tabs"));

var _Tools = _interopRequireWildcard(require("@insided/deprecated-control/integrations/components/bi-tools-connector/Tools"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AwsAthenaParameters = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AwsAthenaParameters, _Component);

  var _super = _createSuper(AwsAthenaParameters);

  function AwsAthenaParameters() {
    var _this;

    (0, _classCallCheck2.default)(this, AwsAthenaParameters);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      activeTab: 0,
      showDetails: true
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setActiveTab", function (selectedTab) {
      _this.setState({
        activeTab: selectedTab
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setShowDetails", function (value) {
      _this.setState({
        showDetails: !value
      });
    });
    return _this;
  }

  (0, _createClass2.default)(AwsAthenaParameters, [{
    key: "render",
    value: function render() {
      var _this$props$awsAthena,
          _this$props$awsAthena2,
          _this$props$awsAthena3,
          _this$props$awsAthena4,
          _this$props$awsAthena5,
          _this$props$awsAthena6,
          _this$props$credentia,
          _this$props$awsAthena7,
          _this$props$awsAthena8,
          _this$props$awsAthena9,
          _this$props$credentia2,
          _this$props$awsAthena10,
          _this$props$awsAthena11,
          _this$props$awsAthena12,
          _this$props$credentia3,
          _this$props$credentia4,
          _this$props$awsAthena13,
          _this2 = this;

      var fieldsPowerBi = [['Region', (_this$props$awsAthena = this.props.awsAthenaData) === null || _this$props$awsAthena === void 0 ? void 0 : _this$props$awsAthena.Region], ['Catalog', (_this$props$awsAthena2 = this.props.awsAthenaData) === null || _this$props$awsAthena2 === void 0 ? void 0 : _this$props$awsAthena2.Catalog], ['Database', (_this$props$awsAthena3 = this.props.awsAthenaData) === null || _this$props$awsAthena3 === void 0 ? void 0 : _this$props$awsAthena3.Database], ['Workgroup', (_this$props$awsAthena4 = this.props.awsAthenaData) === null || _this$props$awsAthena4 === void 0 ? void 0 : _this$props$awsAthena4.Workgroup], ['S3 Output Location', (_this$props$awsAthena5 = this.props.awsAthenaData) === null || _this$props$awsAthena5 === void 0 ? void 0 : _this$props$awsAthena5.OutputLocation], ['Encryption option', (_this$props$awsAthena6 = this.props.awsAthenaData) === null || _this$props$awsAthena6 === void 0 ? void 0 : _this$props$awsAthena6.EncryptionOptions], ['Access Key/Username', (_this$props$credentia = this.props.credentials) === null || _this$props$credentia === void 0 ? void 0 : _this$props$credentia.id]];
      var fieldsTableau = [['Server', (_this$props$awsAthena7 = this.props.awsAthenaData) === null || _this$props$awsAthena7 === void 0 ? void 0 : _this$props$awsAthena7.Server], ['Port', (_this$props$awsAthena8 = this.props.awsAthenaData) === null || _this$props$awsAthena8 === void 0 ? void 0 : _this$props$awsAthena8.Port], ['S3 Staging Directory', (_this$props$awsAthena9 = this.props.awsAthenaData) === null || _this$props$awsAthena9 === void 0 ? void 0 : _this$props$awsAthena9.OutputLocation], ['Access Key/Username', (_this$props$credentia2 = this.props.credentials) === null || _this$props$credentia2 === void 0 ? void 0 : _this$props$credentia2.id]];
      var fieldsLooker = [['Dialect ', 'Amazon Athena'], ['Host', (_this$props$awsAthena10 = this.props.awsAthenaData) === null || _this$props$awsAthena10 === void 0 ? void 0 : _this$props$awsAthena10.Host], ['Port', (_this$props$awsAthena11 = this.props.awsAthenaData) === null || _this$props$awsAthena11 === void 0 ? void 0 : _this$props$awsAthena11.Port], ['Database', (_this$props$awsAthena12 = this.props.awsAthenaData) === null || _this$props$awsAthena12 === void 0 ? void 0 : _this$props$awsAthena12.Database], ['Access Key/Username', (_this$props$credentia3 = this.props.credentials) === null || _this$props$credentia3 === void 0 ? void 0 : _this$props$credentia3.id]];
      var fieldsS3 = [['Access Key/Username', (_this$props$credentia4 = this.props.credentials) === null || _this$props$credentia4 === void 0 ? void 0 : _this$props$credentia4.id], ['Region', (_this$props$awsAthena13 = this.props.awsAthenaData) === null || _this$props$awsAthena13 === void 0 ? void 0 : _this$props$awsAthena13.Region]];
      var child = [(0, _preact.h)("div", {
        key: "power-bi"
      }, (0, _preact.h)(_Tools.default, {
        fields: fieldsPowerBi
      })), (0, _preact.h)("div", {
        key: "looker"
      }, (0, _preact.h)(_Tools.default, {
        fields: fieldsTableau
      })), (0, _preact.h)("div", {
        key: "tableau"
      }, (0, _preact.h)(_Tools.default, {
        fields: fieldsLooker
      })), (0, _preact.h)("div", {
        key: "s3"
      }, (0, _preact.h)(_Tools.default, {
        fields: fieldsS3
      }))];
      return (0, _preact.h)("div", {
        className: "panel-body-container"
      }, (0, _preact.h)("div", {
        className: "panel-body-flex-container"
      }, (0, _preact.h)("div", {
        className: "title-bold"
      }, "Connection Parameters for AWS Athena"), (0, _preact.h)(_Button.default, {
        size: "medium",
        variant: this.state.showDetails ? 'secondary' : 'primary',
        className: "show-hide-btn-no-outline",
        title: this.state.showDetails ? 'Hide Details' : 'Show Details',
        onClick: function onClick() {
          return _this2.setShowDetails(_this2.state.showDetails);
        },
        outlined: false
      })), this.state.showDetails && (0, _preact.h)("div", {
        className: "panel-body-description"
      }, (0, _preact.h)(_tabs.default, {
        titles: ['Power BI', 'Tableau', 'Looker', 'S3'],
        activeTab: this.state.activeTab,
        onCallback: function onCallback(selectedTab) {
          return _this2.setActiveTab(selectedTab);
        },
        className: "data-lake-connector-params"
      }, child)));
    }
  }]);
  return AwsAthenaParameters;
}(_preact.Component);

var AWSAthenaParametersV2 = function AWSAthenaParametersV2(props) {
  var _credentials$id;

  var appName = props.appName,
      awsAthenaData = props.awsAthenaData,
      showAWSConnectionParams = props.showAWSConnectionParams,
      setShowAWSConnectionParams = props.setShowAWSConnectionParams,
      credentials = props.credentials;
  awsAthenaData['Access Key/Username'] = (_credentials$id = credentials === null || credentials === void 0 ? void 0 : credentials.id) !== null && _credentials$id !== void 0 ? _credentials$id : awsAthenaData['Access Key/Username']; // this can be changed

  return (0, _preact.h)("div", {
    className: "panel-body-container"
  }, (0, _preact.h)("div", {
    className: "panel-body-flex-container"
  }, (0, _preact.h)("div", {
    className: "title-bold"
  }, "Copy & Paste the AWS Athena connection parameters in ", appName, " to establish the connection"), (0, _preact.h)(_Button.default, {
    size: "medium",
    variant: showAWSConnectionParams ? 'secondary' : 'primary',
    className: "show-hide-btn-no-outline",
    title: "".concat(showAWSConnectionParams ? 'Hide' : 'Show', " AWS Parameters"),
    onClick: function onClick() {
      return setShowAWSConnectionParams(!showAWSConnectionParams);
    },
    outlined: false,
    customSpanStyle: {
      display: 'inline-flex',
      width: '155px'
    }
  })), showAWSConnectionParams && (0, _preact.h)("div", {
    className: "panel-body-description"
  }, (0, _preact.h)(_Tools.ToolsV2, {
    appName: appName,
    fields: awsAthenaData
  })));
};

exports.AWSAthenaParametersV2 = AWSAthenaParametersV2;
var _default = AwsAthenaParameters;
exports.default = _default;